/**
 * Dawn: Auto-Select + Hide options when "Lieferumfang" = "Nur Board"
 * Adjust these constants if your labels/values differ.
 */
(() => {
  const ONLY_BOARD_VALUE = 'Nur Board';   // must match option value exactly
  const ONLY_BOARD_BLOCK = 'S';           // the block value to force
  const ONLY_BOARD_STUETZE = '15 cm';     // the stütze value to force

  // Label texts (as shown in the option name/legend). Must match roughly.
  const OPTION_NAME_LIEFERUMFANG = 'Lieferumfang';
  const OPTION_NAME_BLOCK = 'Block';
  const OPTION_NAME_STUETZE = 'Stütze';

  function normalize(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function findOptionContainer(variantSelectsEl, optionName) {
    const target = normalize(optionName);

    // Dawn uses fieldset (buttons/radios) OR select dropdowns.
    // Fieldset: <fieldset><legend>Block</legend>...
    const fieldsets = variantSelectsEl.querySelectorAll('fieldset');
    for (const fs of fieldsets) {
      const legend = fs.querySelector('legend');
      if (legend && normalize(legend.textContent).includes(target)) return fs;
    }

    // Select: <label>Block</label><select>...
    const wrappers = variantSelectsEl.querySelectorAll('.product-form__input');
    for (const w of wrappers) {
      const label = w.querySelector('label');
      if (label && normalize(label.textContent).includes(target)) return w;
    }

    return null;
  }

  function getSelectedValue(container) {
    if (!container) return null;

    // Fieldset radios
    const checked = container.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    // Select dropdown
    const select = container.querySelector('select');
    if (select) return select.value;

    return null;
  }

  function setValue(container, value) {
    if (!container) return false;

    // Fieldset radios
    const radios = container.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      const match = Array.from(radios).find(r => r.value === value);
      if (match) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    // Select dropdown
    const select = container.querySelector('select');
    if (select) {
      const hasOption = Array.from(select.options).some(o => o.value === value);
      if (hasOption) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    return false;
  }

  function setHiddenOrDisabled(container, shouldHide) {
    if (!container) return;

    // Hide the whole option UI
    container.style.display = shouldHide ? 'none' : '';

    // Also disable inputs to prevent accidental mismatch via keyboard/autofill
    const inputs = container.querySelectorAll('input, select, button');
    inputs.forEach(el => {
      // Keep radios/selects disabled when hidden; restore when shown
      if (el.matches('input[type="radio"], select')) {
        el.disabled = shouldHide;
      }
    });
  }

  function applyLogic(variantSelectsEl) {
    const lieferumfangEl = findOptionContainer(variantSelectsEl, OPTION_NAME_LIEFERUMFANG);
    const blockEl = findOptionContainer(variantSelectsEl, OPTION_NAME_BLOCK);
    const stuetzeEl = findOptionContainer(variantSelectsEl, OPTION_NAME_STUETZE);

    if (!lieferumfangEl) return;

    const selectedLieferumfang = getSelectedValue(lieferumfangEl);
    const isOnlyBoard = selectedLieferumfang === ONLY_BOARD_VALUE;

    if (isOnlyBoard) {
      // Force a valid combination
      setValue(stuetzeEl, ONLY_BOARD_STUETZE);
      setValue(blockEl, ONLY_BOARD_BLOCK);

      // Hide other options so customer doesn't need to touch them
      setHiddenOrDisabled(stuetzeEl, true);
      setHiddenOrDisabled(blockEl, true);
    } else {
      // Restore UI
      setHiddenOrDisabled(stuetzeEl, false);
      setHiddenOrDisabled(blockEl, false);
    }
  }

  function initOnProductForms() {
    // Dawn uses <variant-selects> element
    const variantSelectsList = document.querySelectorAll('variant-selects');
    variantSelectsList.forEach(vs => {
      // Initial run
      applyLogic(vs);

      // Re-run on any change inside variant selectors
      vs.addEventListener('change', () => applyLogic(vs));
    });
  }

  // Run on load + on Shopify section reloads
  document.addEventListener('DOMContentLoaded', initOnProductForms);
  document.addEventListener('shopify:section:load', initOnProductForms);
})();
